/** Formatage des horaires (BusinessHours) en libellés localisés FR/EN. */
import type { BusinessHours } from '@alterrego/module-merchants-directory';

const DAYS: Record<string, string[]> = {
  fr: ['', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
  en: ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
};

export function dayLabel(dayOfWeek: number, lang: string): string {
  const table = DAYS[lang] ?? DAYS.fr;
  return table[dayOfWeek] ?? '';
}

export function formatSlots(h: BusinessHours): string {
  return h.slots.map((s) => `${s.open} – ${s.close}`).join(' · ');
}
